import styled from 'styled-components';

import { accentFontFamily } from 'views/services/font-scheme';

export const Message = styled.div`
  font-family: ${accentFontFamily};
  font-size: 360px;
  color: white;
  mix-blend-mode: difference;
`;
